import api, { checkTokenErrorResponse } from '..';

export async function postStudent(email, password, nome, sobrenome, nome_responsavel, sobrenome_responsavel ,genero, data_nascimento, iso2_ddi = null, ddi = null, telefone = null, logradouro = null, cidade = null, bairro = null, estado = null, cep = null, foto = null) {
    const formdata = new FormData();
    formdata.append('email', email);
    formdata.append('password', password);

    formdata.append("nome", nome);
    formdata.append("sobrenome", sobrenome);
    formdata.append("nome_responsavel", nome_responsavel);
    formdata.append("sobrenome_responsavel", sobrenome_responsavel);
    formdata.append("genero", genero);
    formdata.append("data_nascimento", data_nascimento);
    formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("ddi", ddi);
    formdata.append("telefone", telefone);
    formdata.append("logradouro", logradouro);
    formdata.append("cidade", cidade);
    formdata.append("bairro", bairro);
    formdata.append("estado", estado);
    formdata.append("cep", cep);
    if (foto !== null)
        formdata.append('foto', foto);

    return api.post("alunos/", formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getStudents() {
    return api.get("alunos/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getStudentInfos(id) {
    return api.get(`alunos/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getStudentPresences(id) {
    return api.get(`alunos/${id}/presencas/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getStudentNotifications(id) {
    return api.get(`alunos/${id}/notificacoes/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteStudentNotification(id, notificationId) {
    return api.delete(`alunos/${id}/notificacoes/${notificationId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function assignReadStudentNotification(id, notificationId) {
    return api.patch(`alunos/${id}/notificacoes/${notificationId}/`, {lido: true})
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchStudentInfos(id, email, password = "",nome, sobrenome, nome_responsavel, sobrenome_responsavel , data_nascimento, iso2_ddi = null, ddi = null, telefone = null, logradouro = null, cidade = null, bairro = null, estado = null, cep = null, foto = null) {
    const formdata = new FormData();
    formdata.append("nome", nome);
    formdata.append("sobrenome", sobrenome);
    formdata.append("nome_responsavel", nome_responsavel);
    formdata.append("sobrenome_responsavel", sobrenome_responsavel);
    formdata.append("data_nascimento", data_nascimento);
    formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("ddi", ddi);
    formdata.append("telefone", telefone);
    formdata.append("logradouro", logradouro);
    formdata.append("cidade", cidade);
    formdata.append("bairro", bairro);
    formdata.append("estado", estado);
    formdata.append("cep", cep);
    formdata.append("email", email);
    if (password !== "")
        formdata.append('password', password)
    if (foto !== null && typeof foto !== "string")
        formdata.append('foto', foto);

    return api.patch(`alunos/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchStudentClass(studentId, turma) {
    return api.patch(`alunos/${studentId}/`, {
        turma
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteStudent(id) {
    return api.delete(`alunos/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function disableStudent(id) {
    return api.patch(`alunos/${id}/desativar_aluno/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function activateStudent(id) {
    return api.patch(`alunos/${id}/ativar_aluno/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchStudentPassword(id, password) {
    
    return api.patch(`alunos/${id}/`, {password})
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postStudentsEmail(titulo, conteudo, ids) {
    
    return api.post("alunos/email/", {titulo, conteudo, ids})
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}


const studentsServices = {
    postStudent,
    getStudents,
    getStudentInfos,
    getStudentPresences,
    getStudentNotifications,
    deleteStudentNotification,
    assignReadStudentNotification,
    patchStudentInfos,
    patchStudentClass,
    deleteStudent,
    disableStudent,
    activateStudent,
    patchStudentPassword,
    postStudentsEmail
}
export default studentsServices;